// COMMISSION — blueprint-spec form. Minimal, sober.
export default function Commission() {
  return (
    <div className="bg-[#DADCD6] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#1E3A5F]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1E3A5F] mb-4">/ Index 04 · Commission inquiry</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em] text-[#1E3A5F]">A note <span className="italic">to the studio</span>.</h1>
        <p className="font-serif italic text-lg lg:text-xl text-[#1B1A18]/65 mt-6 max-w-2xl">We accept eight commissions a year. The earliest start date for new work is currently late 2027. Please do not be deterred by this.</p>
      </section>

      <section className="max-w-[1300px] mx-auto px-6 lg:px-12 py-16 grid lg:grid-cols-[1fr_1.6fr] gap-12 lg:gap-20">
        <aside>
          <div className="border-l-4 border-[#E5C61F] pl-6">
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F] mb-3">/ The studio</p>
            <p className="font-serif text-2xl text-[#1E3A5F]">Hadid & Vance</p>
            <p className="text-sm text-[#1B1A18]/65 mt-3 leading-[1.7]">14 Charlotte Road · Shoreditch<br />London EC2A 3RH</p>
            <p className="font-mono text-[11px] text-[#1B1A18]/55 mt-2">+44 20 7993 0900</p>
            <p className="font-mono text-[11px] text-[#1E3A5F] mt-1">studio@hadid-vance.com</p>
          </div>
        </aside>

        <form className="bg-white border border-[#1E3A5F]/20 p-8 lg:p-12" onSubmit={(e) => e.preventDefault()}>
          <div className="border-b-2 border-[#E5C61F] pb-3 mb-6 flex items-baseline justify-between">
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F]">/ Drawing No. HV-26-INQ</span>
            <span className="font-mono text-[10px] text-[#1E3A5F]/55">REV A · DRAFT</span>
          </div>
          <div className="grid sm:grid-cols-2 gap-5">
            <Spec label="Client" testId="arch-comm-name" />
            <Spec label="Telephone" type="tel" testId="arch-comm-tel" />
            <Spec label="Email" type="email" testId="arch-comm-email" />
            <Spec label="Site location / city" testId="arch-comm-loc" />
          </div>
          <div className="mt-5">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F] block mb-2">/ Typology</label>
            <select className="w-full bg-transparent border-b-2 border-[#1E3A5F]/30 py-2.5 outline-none focus:border-[#E5C61F] font-mono text-sm text-[#1B1A18]" data-testid="arch-comm-type">
              {['Private residence — new build', 'Private residence — adaptive re-use', 'Hospitality', 'Civic / cultural', 'Workplace', 'Other'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
          <div className="mt-5">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F] block mb-2">/ Indicative GFA</label>
            <select className="w-full bg-transparent border-b-2 border-[#1E3A5F]/30 py-2.5 outline-none focus:border-[#E5C61F] font-mono text-sm text-[#1B1A18]" data-testid="arch-comm-gfa">
              {['Under 200 m²', '200 — 500 m²', '500 — 1,500 m²', '1,500 — 5,000 m²', 'Above 5,000 m²'].map(o => <option key={o}>{o}</option>)}
            </select>
          </div>
          <div className="mt-5">
            <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F] block mb-2">/ A note about the brief</label>
            <textarea data-testid="arch-comm-brief" rows="5" className="w-full bg-transparent border-b-2 border-[#1E3A5F]/30 py-2.5 outline-none focus:border-[#E5C61F] resize-none font-serif text-base text-[#1B1A18]" placeholder="The site, the use, anyone you have worked with before, anything we should know." />
          </div>
          <button type="button" data-testid="arch-comm-submit" className="mt-8 bg-[#1E3A5F] text-[#E5C61F] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#E5C61F] hover:text-[#1E3A5F] transition-colors">Send to the studio →</button>
        </form>
      </section>
    </div>
  );
}
function Spec({ label, type = 'text', testId }) {
  return (
    <div>
      <label className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F] block mb-2">/ {label}</label>
      <input data-testid={testId} type={type} className="w-full bg-transparent border-b-2 border-[#1E3A5F]/30 py-2.5 outline-none focus:border-[#E5C61F] font-serif text-base text-[#1B1A18]" />
    </div>
  );
}
